import type { AllAuthClientConfigT, AllAuthClientT } from '../types';
import { createUserApiAuthClient } from './userApi/userApiAuth';

export * from '../types';

export default function createAllAuthClient({
  baseUrl,
}: AllAuthClientConfigT): AllAuthClientT {
  const userApiAuth = createUserApiAuthClient({ baseUrl });
  return {
    login: userApiAuth.login,
    signup: userApiAuth.signup,
  };
}
